"use client"

import { Box, Button, H2, H4, P } from "@bullseye/components"

type BlogPreviewProps = {
  copy: {
    heading: string
    subheading: string
    posts: Array<{
      title: string
      url: string
      image_url: string
      description: string
    }>
  }
}

const BlogPreview = ({ copy }: BlogPreviewProps) => {
  return (
    <Box className="px-4 py-20 g-10">
      <Box className="flex">
        <H2 className="pb-2 text-center font-bold">{copy.heading}</H2>
        <P className="text-center">{copy.subheading}</P>
      </Box>
      <Box className="flex flex-wrap items-center justify-center g-6 md:flex-row">
        {copy.posts.map((blogCard, index) => (
          <Box
            key={index}
            className="flex h-[400px] max-w-[380px] overflow-hidden rounded-lg border border-solid border-gray-100 shadow-lg"
          >
            <a href={blogCard.url}>
              <img
                alt="post image"
                src={blogCard.image_url}
                style={{
                  height: "200px",
                  width: "100%",
                  objectFit: "cover",
                  objectPosition: "50% 50%",
                }}
              />
            </a>
            <Box className="flex p-4">
              <H4 className="p-2 text-brand-indigo-1">
                <a href={blogCard.url} style={{ textDecoration: "none" }}>
                  {blogCard.title}
                </a>
              </H4>
              <P>{blogCard.description}</P>
            </Box>
          </Box>
        ))}
      </Box>
      <Box className="flex items-center justify-center">
        <Button as="a" href="/blog" height="lg" className="!w-[240px]">
          View all blog posts
        </Button>
      </Box>
    </Box>
  )
}
export default BlogPreview
